// language=GraphQL
export const ALL_PERMISSIONS_QUERY = `query Query {
  permissions: rbacPermissions {
    id
    path
    module
    name
  }
}`

// language=GraphQL
export const SINGLE_PERMISSION_QUERY = `query Query($id: ID!) {
  permission: rbacPermission(id: $id) {
    id
    path
    module
    name
  }
}`

// language=GraphQL
export const CREATE_PERMISSION_MUTATION = `
  mutation Mutation($input: CreateRbacPermissionInput) {
    permission: createRbacPermission(input: $input) {
      id
      path
      module
      name
    }
  }`

// language=GraphQL
export const UPDATE_PERMISSION_MUTATION = `
  mutation Mutation($input: UpdateRbacPermissionInput) {
    permission: updateRbacPermission(input: $input) {
      id
      path
      module
      name
    }
  }`

// language=GraphQL
export const DELETE_PERMISSION_MUTATION = `
  mutation Mutation($input: DeleteRbacPermissionInput) {
    deleteRbacPermission(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PERMISSION_MUTATION = `
  mutation Mutation($input: DeleteRbacPermissionInput) {
    forceDeleteRbacPermission(input: $input) {
      success
    }
  }`
// language=GraphQL
export const PERMISSIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRbacRoles: Boolean = false) {
  groupedDependents: rbacPermissionDependents(id: $id) {
    rbacRoles @include(if: $withRbacRoles) {
      id
      name
      description
    }
  }
}`
